import { useRef, useState } from "react";
import { Camera, Images, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { uploadFile } from "@/lib/noleggio";
import { useI18n } from "@/lib/i18n";

/** Two buttons (camera / gallery) that upload a picture and return the backend response. */
export default function PhotoButtons({ path, prefix, onUploaded, successKey, successText }) {
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);
  const camRef = useRef(null);
  const galRef = useRef(null);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const d = await uploadFile(path, file);
      onUploaded(d, URL.createObjectURL(file), file);
      toast.success(successText ?? t(successKey));
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex gap-2">
      <button type="button" data-testid={`${prefix}-camera`} disabled={busy} onClick={() => camRef.current.click()} className="mn-btn mn-btn-ghost flex-1 !min-h-[42px] !px-3 text-sm">
        {busy ? <Loader2 size={16} className="animate-spin" /> : <Camera size={16} />} {t("take_photo")}
      </button>
      <button type="button" data-testid={`${prefix}-library`} disabled={busy} onClick={() => galRef.current.click()} className="mn-btn mn-btn-ghost flex-1 !min-h-[42px] !px-3 text-sm">
        <Images size={16} /> {t("from_gallery")}
      </button>
      <input ref={camRef} type="file" accept="image/*" capture="environment" hidden onChange={onFile} data-testid={`${prefix}-camera-input`} />
      <input ref={galRef} type="file" accept="image/*" hidden onChange={onFile} data-testid={`${prefix}-file-input`} />
    </div>
  );
}
